<ds-modal variant="surface" bottomSheet="true" class="wallet-detail-dialog">
    <ds-modal-header variant="surface-low" class="wallet-detail-dialog__header">
        <div slot="start">
            <div slot="title">Balance details</div>
        </div>
        <button ds-button slot="end" kind="secondary" variant="outline" size="medium" (click)="close()">Close</button>
    </ds-modal-header>

    <ds-modal-content>
        <div class="wallet-detail-dialog__content">
            @for (item of data?.item; track trackByProp($index, item)) {
                <ng-container *vnDynamicComponent="getItemComponent(item.type); attr: { item: item }" />
            }
        </div>
    </ds-modal-content>
</ds-modal>
